import {
  acceptCompletion,
  closeBracketsKeymap,
  completionKeymap,
  selectedCompletion,
} from '@codemirror/autocomplete';
import {
  copyLineDown,
  copyLineUp,
  historyKeymap,
  indentLess,
  standardKeymap,
  toggleBlockComment,
  toggleLineComment,
} from '@codemirror/commands';
import { foldKeymap } from '@codemirror/language';
import { EditorView, keymap } from '@codemirror/view';
import { type MutableRefObject } from 'react';

import { indentWithSpaces } from './indent-with-spaces.js';

/** Returns the default key maps for the editor */
export const getKeyMaps = (viewRef: MutableRefObject<EditorView>) => {
  return [
    keymap.of([
      {
        key: 'Enter',
        run: (target) => {
          const _selectedCompletion = selectedCompletion(target.state);
          const textToCursor = target.state.doc
            .slice(0, target.state.selection.main.to)
            .toString();
          if (
            _selectedCompletion !== null &&
            textToCursor.endsWith(_selectedCompletion?.label)
          ) {
            acceptCompletion(target);
            return false;
          }
          return acceptCompletion(target);
        },
      },
      ...completionKeymap,
      ...closeBracketsKeymap,
      ...standardKeymap,
      ...historyKeymap,
      ...foldKeymap,
      {
        key: 'Mod-7',
        run: toggleLineComment,
      },
      {
        key: 'Mod-/',
        run: toggleLineComment,
      },
      {
        key: 'Shift-Alt-a',
        run: toggleBlockComment,
      },
      {
        key: 'Shift-Alt-ArrowUp',
        run: copyLineUp,
      },
      {
        key: 'Shift-Alt-ArrowDown',
        run: copyLineDown,
      },
      {
        key: 'Tab',
        run: (target) => {
          if (selectedCompletion(target.state) !== null) {
            return acceptCompletion(target);
          }
          return indentWithSpaces(target);
        },
        // SHIFT+TAB fix
        shift: indentLess,
      },
      {
        key: 'Escape',
        run: () => {
          (
            viewRef.current.dom.querySelector('.cm-scroller') as HTMLElement
          )?.focus();
          return true;
        },
      },
    ]),
  ];
};
